import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, color = 'primary' }) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <div className="flex items-baseline space-x-2">
            <h3 className="text-2xl font-semibold text-foreground">{value}</h3>
            {trend && (
              <span className={`text-sm font-medium ${
                trend?.type === 'positive' ? 'text-success' : 
                trend?.type === 'negative' ? 'text-destructive' : 'text-muted-foreground'
              }`}>
                {trend?.value}
              </span>
            )}
          </div>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div className={`h-12 w-12 rounded-lg bg-${color}/10 flex items-center justify-center`}>
          <Icon name={icon} size={24} className={`text-${color}`} />
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;